import Box from "@mui/material/Box";
import styled from "styled-components";

export const StyledDateMonthPicker = styled(Box)`
  display: flex;
  flex-direction: column;
  min-width: 200px;

  .label {
    font-size: 14px;
    margin-bottom: 4px;
    color: ${({ theme }) => theme.custom?.primary?.dark || '#1a4fd9'};
  }
`;
